import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["title", "onClick", "isActive", "level"];
import PropTypes from 'prop-types';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import styled from 'styled-components';
import { SLINKY, EERIE, OLAF } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const NavItemWrapper = styled.div.withConfig({
  displayName: "EPPatagoniaCategoryNavItem__NavItemWrapper",
  componentId: "tyyt06-0"
})([".patagonia-sidebar-category-item{padding:14px 12px 14px 12px;&.active-level-1{background-color:", ";color:", ";}&.active-level-2{background-color:", ";color:", ";}}"], SLINKY, OLAF, EERIE, OLAF);
const EPPatagoniaCategoryNavItem = navItem => {
  const {
      title,
      onClick,
      isActive,
      level = 1
    } = navItem,
    rest = _objectWithoutPropertiesLoose(navItem, _excluded);
  return /*#__PURE__*/_jsx(NavItemWrapper, {
    children: /*#__PURE__*/_jsx(UISideNavItem, Object.assign({
      title: title,
      className: isActive ? `patagonia-sidebar-category-item active-level-${level}` : 'patagonia-sidebar-category-item',
      onClick: onClick
    }, rest))
  });
};
EPPatagoniaCategoryNavItem.propTypes = {
  title: PropTypes.object.isRequired,
  onClick: PropTypes.func
};
export default EPPatagoniaCategoryNavItem;